<template>
  <div
    v-if="display && showComponent"
    :title="qaAble ? showIfHasPermission?.toString() : null"
    :key="componentRefresh"
  >
    <div style="display:flex;flex-direction:column">

      <ks-dropzone
        v-show="!editing"
        :ref="`dropzone-${_uid}`"
        :multiple="multiple"
        :disabled="disabled||!enableComponent"
        :maxSizeFile="maxSizeFile"
        @onChange="filesHandler"
      />

      <template v-if="editing">
        <ks-flex v-if="previewFiles.length > 0" justify="center">
          <ks-button 
            color="link" 
            classIcon="fas fa-arrow-left" 
            @onClick="editFile(selectedFile.index - 1)"
            :disabled="selectedFile.index === 0"
          />
          <ks-space/>
          {{ selectedFile.index + 1 }} of {{ previewFiles.length }}
          <ks-space/>
          <ks-button 
            color="link" 
            classIcon="fas fa-arrow-right" 
            @onClick="editFile(selectedFile.index + 1)"
            :disabled="selectedFile.index === previewFiles.length - 1"
          />
        </ks-flex>

        <div class="input-group">
          <input type="text" class="form-control" placeholder="File Name" v-model="fileNameInput">
        </div>

        <template v-if="enableCropper(selectedFile.name)">
          <ks-image-cropper
            :src="selectedFile.src"
            :fileName="selectedFile.name"
            @crop="crop"
            @reset="crop"
          />
        </template>
        <template v-else>
          <iframe 
            :src="selectedFile.src" 
            border="none"
            style="width:100%; height:100%"
          />
        </template>
      </template>

      <template v-if="previewFiles.length > 0">

        <div style="display: flex;flex-direction:column">
          <ks-text text="File(s) to upload preview:" />

          <ks-file-list 
            :files="previewFiles"
            :showDefaultGrid="false"
            :showDefaultRow="false"
          >
            <template #grid="{files}">
              <div class="file-mosaic" :style="{'max-height':height, 'width': width}">
                <div class="file-mosaic-item" v-for="(file, idx) in files">
                  <div class="options">
                    <a href="" style="color: blue;" class="button" @click.prevent="editFile(idx)"><i class="fa fa-edit" aria-hidden="true"></i> </a>
                    <a href="" style="color: red;" class="button" @click.prevent="removeFile(idx)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                  <img :src="file._src" @click.prevent="editFile(idx)"/>
                </div>
              </div>
            </template>

            <template #row="{files}">
              <div class="file-row" :style="{'max-height':height, 'width': width}">
                <div class="file-row-item" v-for="(file, idx) in files">
                    <div style="width:60px;height:60px;" class="file-mosaic-item" >
                      <img :src="file._src" @click.prevent="editFile(idx)"/>
                    </div>
                    <a href="" @click.prevent="editFile(idx)">{{ file.name }}</a>
                    <div class="options">
                      <a href="" style="color: blue;" class="button" @click.prevent="editFile(idx)"><i class="fa fa-edit" aria-hidden="true"></i> </a>
                      <a href="" style="color: red;" class="button" @click.prevent="removeFile(idx)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                    </div>
                </div>
              </div>
            </template>
          </ks-file-list>

          <div style="display:flex; flex-direction:column" v-if="uploadErrors.length > 0">
            <span v-for="error in uploadErrors" class="text-danger">{{ error }}</span>
          </div>

          <div style="display: flex;margin-left: auto;" v-if="showDefaultNavigation">
            <ks-button
              v-show="!uploadLoading"
              @onClick="upload"
              :label="`Upload ${previewFiles.length > 1 ? '(all)':''}`"
              classIcon="fa fa-upload"
            />
            <ks-button
              v-show="uploadLoading"
              :disabled="true"
              :label="`Upload ${previewFiles.length > 1 ? '(all)':''}`"
              classIcon="fas fa-spinner fa-pulse"
            />

            <ks-button
              v-if="editing"
              class="ml-2"
              color="secondary"
              @onClick="closeEdit"
              label="Close Edit"
              classIcon="fa fa-times"
            />
            <ks-button
              v-else
              class="ml-2"
              color="danger"
              @onClick="cancel"
              label="Cancel"
              classIcon="fa fa-ban"
            />
          </div>
        </div>

      </template>

    </div>
  </div>
</template>
<script>
import checkPermissions from '../../mixins/checkPermissions';
import fileTypeIs from '../../mixins/fileTypeIs';

export default {
  name: 'upload-file',
  mixins: [checkPermissions, fileTypeIs],
  props: {
    multiple:{
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: true
    },
    maxSizeFile: {
      type: Number, //MB
      default: null
    },
    uploadOptions:{
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '27dvh'
    },
    width:{
      type: String,
      default: '100%'
    },
    showDefaultNavigation:{
      type: Boolean,
      default: true
    }
  },
  watch: {
    fileNameInput(newVal) {
      if(this.timeout){
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        const dt = new DataTransfer();
        for(let i = 0; i < this.files.length; i++){
          if(i==this.selectedFile.index) dt.items.add(new File([this.files[this.selectedFile.index]], newVal, {type: this.selectedFile.type})); 
          else dt.items.add(this.files[i]);
        }
        this.$refs[`dropzone-${this._uid}`].set(dt.files);
        this.filesHandler(dt);
      }, 1500);
    },
    mode(){
      this.$emit('onChangeMode', this);
    },
    uploadLoading(){
      this.$emit('onUploadLoading', this);
    }
  },
  computed: {
    mode(){
      return this.editing ? 'edit' : this.files.length > 0 ? 'upload' : 'default';
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    dataProviderName() {
      return this.$parent.dataProvider;
    },
    dataProvider() {
      return this.$parent.data_provider_ref;
    },
    computedValidationStatus() {
      return this.isValid === null ? "none" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
    },
    previewFiles() {
      let fileArray = Array.from(this.files);
      return fileArray.map((file, index) => {
        let fileExtension = file.name?.split(".").pop();
        if (fileExtension == 'pdf') {
          file["_src"] = require("../../assets/images/pdf.jpeg");
          file.src = window.URL.createObjectURL(file);
        } else if (this.fileTypeIs('audio', fileExtension)) {
          file["_src"] = require("../../assets/images/audio.png");
          file.src = window.URL.createObjectURL(file);
        } else if (this.fileTypeIs('video', fileExtension)) {
          file["_src"] = require("../../assets/images/video.jpg");
          file.src = window.URL.createObjectURL(file);
        } else {
          file["_src"] = window.URL.createObjectURL(file);
          file.src = window.URL.createObjectURL(file);
        }
        file["index"] = index;
        return file;
      }); 
    }
  },
  mounted() {},
  methods: {
    
    filesHandler({files}){
      this.files = files;
      this.$emit('onChange', this);
    },

    removeFile(index) {
      this.$refs[`dropzone-${this._uid}`].removeFile(index);
      if(this.selectedFile){
        if(this.selectedFile.index == index){
          if(this.previewFiles.length > 0 ) this.selectedFile = this.previewFiles[0];
          else this.cancel();
        }else if(this.selectedFile.index !== 0){
          this.selectedFile.index = index-1;
        }
      }
      this.$emit('onRemoveFile', this);
    },

    editFile(index) {
      this.selectedFile = this.previewFiles[index];
      this.fileNameInput = this.selectedFile.name;
      this.editing = true;
      this.$emit('onOpenEdit', this);
    },

    crop(file) {
      const dt = new DataTransfer();
      for(let i = 0; i < this.files.length; i++){
        if(i==this.selectedFile.index) dt.items.add(file); 
        else dt.items.add(this.files[i]);
      }
      this.$refs[`dropzone-${this._uid}`].set(dt.files);
      this.filesHandler(dt);
    },

    cancel() {
      let dt = new DataTransfer();
      this.editing = false;
      this.$refs[`dropzone-${this._uid}`].set(dt.files);
      this.filesHandler(dt);
      this.uploadErrors = [];
      this.selectedFile = null;
      this.$emit('onCancel', this);
    },

    closeEdit(){
      this.editing = false;
      this.selectedFile = null;
      this.$emit('onCloseEdit', this);
    },

    enableCropper(fileName) {
      if (!fileName) return false;
      let fileExtension = fileName.split(".").pop();
      return this.fileTypeIs('image', fileExtension);
    },

    async upload(){
      this.uploadLoading = true;
      this.uploadErrors = [];
      try{
        const result = await app.data.create("file.file", this.uploadOptions, this.files);
        app.toast("Files Uploaded Successfully", "success");
        this.$emit('onUpload', {ref:this, result: result});
        this.cancel();
        this.uploadLoading = false;
      }catch(err){
        if(Array.isArray(err))this.uploadErrors = err.map(err => err.error_text);
        else this.uploadErrors = [err];
        app.toast(`Upload Error: ${this.uploadErrors[0]}`, "danger");
        this.$emit('onUploadError', {ref:this, error: err});
        this.uploadLoading = false;
      }
    }

  },
  data() {
    let dt = new DataTransfer();
    return {
      editing: false,
      files: dt.files,
      selectedFile: null,
      imageSrc: null,
      fileNameInput: null,
      timeout: null,
      uploadErrors: [],
      uploadLoading: false
    }
  }
}
</script>